import { rootApi } from "../../api/rootApi";

export const ecommerceSizesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all sizes
    fetchEcommerceSizes: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/sizes/all`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),

    // Add size
    addEcommerceSize: builder.mutation({
      query: ({ slug, token, ...body }) => ({
        url: `/tenant/ecommerce/sizes/add`,
        method: "POST",
        headers: {
          slug,
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body,
      }),
    }),
  }),
});

export const {
  useFetchEcommerceSizesMutation,
  useAddEcommerceSizeMutation,
} = ecommerceSizesApi;
